import React, { useState, useEffect, useRef } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { Button, Form, FormLabel } from "react-bootstrap";
import type { ErpProjectListItemDto } from "../../../api/generated/model";
import "./DropDownSelectProject.css";

type DropDownSelectProjectProps = {
  projects?: ErpProjectListItemDto[];
  setSelectedProjectNumber: React.Dispatch<React.SetStateAction<string | undefined>>;
  setErpReference: React.Dispatch<React.SetStateAction<string | undefined>>;
  setDepartment: React.Dispatch<React.SetStateAction<number | undefined>>;
};

const DropDownSelectProject: React.FC<DropDownSelectProjectProps> = (props) => {
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);

  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleSelectProject = (projectId: string, projectName: string) => {
    const selectedProject = props.projects?.find(
      (x) => String(x.projectId ?? "") === projectId
    );
    const department = selectedProject?.department;
    const erpReference = selectedProject?.erpReference;
    props.setSelectedProjectNumber(projectId);
    props.setErpReference(erpReference ?? undefined);
    props.setDepartment(department);
    setSearchTerm(`${projectName} - (${projectId})`);
    setIsDropdownOpen(false);
  };

  const filteredProjects = Array.isArray(props.projects) ? props.projects?.filter(
    (project) =>
      (project.projectName ?? "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      String(project.projectId ?? "").toLowerCase().includes(searchTerm.toLowerCase())
  ) : [];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Form>
      <FormLabel>Projekt</FormLabel>
      <div ref={dropdownRef} className="project-dropdown-wrapper">
        <Form.Control
          type="text"
          placeholder="Sök Projekt..."
          className="pe-5"
          value={searchTerm}
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setIsDropdownOpen(true);
          }}
        />
        {searchTerm && (
          <Button
            variant="link"
            className="project-clear-input-button"
            type="button"
            onClick={() => {
              setSearchTerm("");
              setIsDropdownOpen(true);
            }}
          >
            <CloseOutlined />
          </Button>
        )}
        {isDropdownOpen && (
          <div className="project-list-container">
            {filteredProjects &&
              filteredProjects.map((project) => (
                <div
                  key={project.projectId}
                  onClick={() => handleSelectProject(String(project.projectId ?? ""), project.projectName ?? "")}
                  className="project-list-item"
                >
                  {project.projectName} - ({project.projectId})
                </div>
              ))}
          </div>
        )}
      </div>
    </Form>
  );
};

export default DropDownSelectProject;